/** Sanitize numeric ids / check if number to prevent useless api calls */
export const getSanitizedId = (inputId?: string): string | null => {
    const id = Number(inputId);
    if (!inputId || Number.isNaN(id) || !Number.isInteger(id)) {
        return null;
    }

    return inputId;
};
